export { default } from "./useSetAssignmentActivities";
